import { clearSubjectSchema, setSubjectSchema } from "../redux/subjectSchemaSlice";

let subjectSchemaRequest = null;
let cachedSubjectSchema = null;

const checkUpdateSubjectSchema = async (dispatch, currentSubjectSchema = [], options = {}) => {
    const { returnData = false } = options;

    if (Array.isArray(currentSubjectSchema) && currentSubjectSchema.length > 0) {
        cachedSubjectSchema = currentSubjectSchema;
        return returnData ? currentSubjectSchema : true;
    }

    if (Array.isArray(cachedSubjectSchema) && cachedSubjectSchema.length > 0) {
        dispatch(setSubjectSchema(cachedSubjectSchema));
        return returnData ? cachedSubjectSchema : true;
    }

    if (subjectSchemaRequest) {
        const pendingSchema = await subjectSchemaRequest;
        return returnData ? pendingSchema : !!pendingSchema;
    }

    subjectSchemaRequest = (async () => {
        const requestOptions = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                scopeName: "profile"
            })
        };

        try {
            const response = await fetch('https://' + process.env.REACT_APP_OP_HOST + '/iap-api/get-user-attributes', requestOptions);
            const result = await response.json();
            const arrayOfObjects = Object.entries(result || {}).map(([key, value]) => {
                return { name: key, ...value };
            });

            cachedSubjectSchema = arrayOfObjects;
            dispatch(setSubjectSchema(arrayOfObjects));
            return arrayOfObjects;

            // // Data Test
            // const subjectAttributeTest = [
            //     { name: 'displayName', attributeType: 'string' },
            //     { name: 'sn', attributeType: 'string' },
            //     { name: 'givenName', attributeType: 'string' },
            //     { name: 'gender', attributeType: 'string' },
            //     { name: 'userApproved', attributeType: 'string' },
            //     { name: 'registerTimestamp', attributeType: 'string' },
            //     { name: 'statusNewOrg', attributeType: 'string' },
            //     { name: 'emailVerified', attributeType: 'boolean' },
            //     { name: 'areaCode', attributeType: 'Array' },
            // ];

            // cachedSubjectSchema = subjectAttributeTest;
            // dispatch(setSubjectSchema(subjectAttributeTest));
            // return subjectAttributeTest;
        } catch (error) {
            console.error(error);
            cachedSubjectSchema = [];
            dispatch(clearSubjectSchema());
            return false;
        } finally {
            subjectSchemaRequest = null;
        }
    })();

    const schema = await subjectSchemaRequest;
    return returnData ? schema : !!schema;
}

export default checkUpdateSubjectSchema;